// file-upload.component.ts
import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-upload-files-upload',
  templateUrl: './upload-files-view.component.html',
})
export class UploadFilesViewComponent {
  files: File[] = [];
  fileNames: string[] = [];
  errorMessage: string = '';

  constructor(private http: HttpClient) {}

  onFileSelect(event: any): void {
    const selectedFiles: FileList = event.target.files;
    if (selectedFiles.length > 0) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        this.files.push(file);
        this.fileNames.push(file.name);
      }
    }
  }

  onSubmit(): void {
    if (this.files.length === 0) {
      this.errorMessage = 'Please select files to upload.';
      return;
    }

    // Check for file types (e.g., pdf, jpg, png)
    const allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
    const maxSize = 5 * 1024 * 1024; // 5 MB limit

    for (let file of this.files) {
      const fileExtension = file.name.split('.').pop();
      if (!allowedExtensions.includes(fileExtension?.toLowerCase() || '')) {
        this.errorMessage = `Invalid file type: ${file.name}`;
        return;
      }
      if (file.size > maxSize) {
        this.errorMessage = `File size exceeds 5MB: ${file.name}`;
        return;
      }
    }

    const formData = new FormData();
    this.files.forEach(file => {
      formData.append('files[]', file, file.name);
    });

    this.http.post('/api/upload', formData).subscribe(
      (response) => {
        console.log('Upload successful', response);
        // Handle success (e.g., show success message or redirect)
      },
      (error) => {
        console.error('Upload failed', error);
        this.errorMessage = 'Failed to upload files.';
      }
    );
  }
}
